// The status the database worked out (app_get_profile_qualifications_v5): the
// matrix's rules, with the company's "expiring soon" threshold. Mapped onto the
// display statuses the cards and filters already use.
const FROM_EFFECTIVE_STATUS = {
  valid: 'completed',
  expiring: 'expiring_soon',
  expired: 'expired',
  missing: 'not_started',
}

// Only for rows cached offline before v3, which carry no effective_status.
const LEGACY_EXPIRING_DAYS = 30

export function getDisplayStatus(qual) {
  const fromServer = FROM_EFFECTIVE_STATUS[qual.effective_status]
  if (fromServer) return fromServer

  const status = qual.status
  if ((status === 'completed' || status === 'evidenced') && qual.expiry_date) {
    const expiry = new Date(qual.expiry_date)
    const now = new Date()
    if (expiry <= now) return 'expired'
    if (expiry - now < LEGACY_EXPIRING_DAYS * 24 * 60 * 60 * 1000) return 'expiring_soon'
    return 'completed'
  }
  if (status === 'completed' || status === 'evidenced') return 'completed'
  return status || 'pending'
}
